module.exports = __webpack_public_path__ + "static/img/github.5d0411a5.svg";